import { ClerkAuthLoader } from '@/components/auth/ClerkAuthLoader'
import { useDarkMode } from '@/hooks/useDarkMode'
import { ClerkProvider as ClerkProviderOriginal } from '@clerk/clerk-react'
import { dark } from '@clerk/themes'
import type { ReactNode } from 'react'

export function ClerkProvider({ children }: { children: ReactNode }) {
  const isClerkEnabled = window.env.CLERK_ENABLED
  const prefersDarkMode = useDarkMode()

  if (!isClerkEnabled) {
    return <>{children}</>
  }

  return (
    <ClerkProviderOriginal
      publishableKey={window.env.CLERK_PUBLISHABLE_KEY}
      appearance={{
        baseTheme: prefersDarkMode ? dark : undefined,
      }}
      signInUrl="/sign-in"
      signUpUrl="/sign-in"
    >
      <ClerkAuthLoader />
      {children}
    </ClerkProviderOriginal>
  )
}
